import getPaymentConfig from "common/services/payments/getPaymentConfig"
import cuckoo from "../services/cuckoo/cuckoo"

export const detectionOfNativePayment = async () => {
  const supportedInstruments = [
    {
      supportedMethods: ["basic-card"],
      data: {
        supportedNetworks: Object.keys(getPaymentConfig().payments.card.card_types),
      },
    },
  ]

  if (window.PaymentRequest) {
    const summary = {
      displayItems: [
        {
          label: "Sub-total",
          amount: { currency: "USD", value: "55.00" },
        },
      ],
      total: {
        label: "Total due",
        amount: { currency: "USD", value: "65.00" },
      },
    }
    const request = new PaymentRequest(supportedInstruments, summary)

    if (request.canMakePayment) {
      return request.canMakePayment().catch(() => false)
    }
    return false
  }

  return false
}

export default async function featureDetection() {
  const features = {
    paymentRequest: false,
    canMakePayment: false,
    applePay: false,
  }

  // can be detected from user agent
  if (window.PaymentRequest) {
    features.paymentRequest = true
  }

  if (window.ApplePaySession) {
    features.applePay = true
  }

  // cant be detected from user agent
  features.canMakePayment = await detectionOfNativePayment()

  cuckoo.infinario("FeatureDetection", {
    action: "payment",
    ...features,
  })
}
